import * as Types from './machineParameterActionTypes.js'

const initialState = {
    rpmPump: [],
    speed: [],
};

export default function machineParameter(state = initialState, action) {
    switch (action.type) {
        case Types.SET_RPMPUMP:
            if (state.rpmPump !== action.rpmPump) {
                return Object.assign({}, state, { rpmPump: action.rpmPump });
            }
            return state;
        case Types.SET_SPEED:
            console.log("SET_SPEED, current state");
            console.log(state.speed)
            console.log("SET_SPEED, received state");
            console.log(action.speed)
            if (state.speed !== action.speed) {
                console.log("SET_SPEED, new state after update");
                console.log(state.speed)
                return Object.assign({}, state, { speed: action.speed });
            }
            // console.log("SET_SPEED, new state without update");
            // console.log(state.speed)
            return state;
     
        default:
            return state;
    }
}